import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';
import { ResultModel } from "../models/result.model";
import { ProvinceModel } from '../models/province.model';
import { DistrictModel } from '../models/district.model';

@Injectable({
  providedIn: 'root'
})
export class AddressService extends BaseService {


  listAllProvince() {
    return this.httpClient.get<ResultModel<ProvinceModel[]>>(this.getApiUrl('addresses/provinces'));
  }


  listAllDistrict(provinceID: string | number) {
    return this.httpClient.get<ResultModel<DistrictModel[]>>(this.getApiUrl(`addresses/provinces/${provinceID}/districts`));
  }


}
